import { render } from "./ConfigPage.vue?vue&type=template&id=ff1e7f08&ts=true"
import script from "./ConfigPage.vue?vue&type=script&lang=ts"
export * from "./ConfigPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__